import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {
	C1BillResult,
	CarrierBillDto,
	ContainerData,
	ContainerResponse,
	ForeignPortCode, MessageListResponse,
	PortCode, ProfileManufacturerAgreementDto, RequestResponse, SubmissionData,
	TemplateDto, TemplateSubmisionRequest,
	Vessel, VShipperSubmission
} from "../shipper";
import {ISFListFilterData} from "./isf/list/isf.list.filter";
import {Observable} from "rxjs";


@Injectable({providedIn: "root"})
export class TemplateService{
	
	
	constructor(private http:HttpClient) {}
	
	
	/**
	 *
	 * @param request
	 */
	search(request:ISFListFilterData){
		return this.http.post<MessageListResponse<VShipperSubmission>>(`io/isf/list`,request);
	}
	
	
	
	/**
	 *
	 * @param request
	 */
	submitIsf(request:TemplateSubmisionRequest){
		//console.log("REQ",request);
		return this.http.post(`io/isf`,request);
	}
	
	
	/**
	 *
	 * @param id
	 */
	getIsf(id:number){
		return this.http.get<SubmissionData>(`io/isf/${id}`);
	}
	
	
	/**
	 *
	 */
	getTemplates(){
		return this.http.get<Array<TemplateDto>>(`io/templates`);
	}
	
	
	
	/**
	 *
	 * @param term
	 */
	getVessels(term:string){
		return this.http.get<Vessel[]>(`io/search/vessels`,{params:{term:term.toUpperCase()}})
	}
	
	
	/**
	 *
	 * @param term
	 */
	getPortCodes(term:string){
		return this.http.get<PortCode[]>(`io/search/ports`,{params:{term:term.toUpperCase()}})
	}
	
	
	/**
	 *
	 * @param term
	 */
	getForeignPortCodes(term:string){
		return this.http.get<ForeignPortCode[]>(`io/search/foreign-ports`,{params:{term:term.toUpperCase()}})
	}
	
	
	/**
	 *
	 * @param bills
	 */
	validateScacs(bills:Array<string>){
		return this.http.post<CarrierBillDto[]>(`io/search/carriers`,bills);
	}
	
	
	/**
	 *
	 * @param containerNumber
	 */
	getOrCreateContainer(containerNumber:string){
		return this.http.post<ContainerData>(`io/containers/${containerNumber}`,{});
	}
	
	
	/**
	 *
	 * @param containerNumbers
	 */
	getOrCreateContainers(containerNumbers:Array<string>){
		return this.http.post<ContainerResponse>(`io/search/containers`,containerNumbers);
	}
	
	
	/**
	 *
	 * @param id
	 */
	pdfConfirmation(id:number):Observable<Blob>{
		
		return this.http.get(`io/isf/confirmation/${id}`,{
			responseType: "blob",
			headers: new HttpHeaders().append('Content-Type', 'application/pdf')
		});
	}
	
	
	/**
	 *
	 * @param id
	 */
	getQueryResult(id:number):Observable<C1BillResult[]>{
		return this.http.get<C1BillResult[]>(`io/isf/c1/${id}`);
	}
	
	
	/**
	 * Get terms & conditions for user/profile/shipper
	 */
	getTerms(){
		return this.http.get<ProfileManufacturerAgreementDto[]>(`io/terms`);
	}
	
	
	/**
	 *
	 * @param agreemetns
	 */
	setTerms(agreemetns:Array<ProfileManufacturerAgreementDto>){
		return this.http.post<RequestResponse>(`io/terms`, agreemetns)
	}
}
